<template>
  <div v-if="product.id > 0"
       class="page-group-buy-team-detail"
  >
    <div class="block-section">
      <group-buy-product class="group-buy-product"
                         :cover="product.cover"
                         :title="product.title"
                         :price="render.primaryPrice"
                         :team-size="activity.teamSize"
                         :product-id="product.id"
                         :product-type="product.productType"
      />
      <div class="team-action-container"
           v-if="team.status"
      >
        <team-status :status="team.status"
                     :buttons="render.buttons"
                     :team-size="activity.teamSize"
                     :member-length="team.members.length"
                     :current-time="currentTime"
                     :expired-time="team.expiredTime"
                     :product-title="product.title"
                     :origin-price="originPrice"
                     :share-path="$wechat.getWechatMenuShareAppLink()"
        />
      </div>
    </div>
    <group-buy-team-member-list class="block-section"
                                :show-follow="team.isMember"
                                :members="team.members"
                                :qrCode="qrCode"
    />
    <group-buy-rule :rule="activity.rule" />
  </div>
</template>

<script>
  import GroupBuyProduct from '@/pages/GroupBuy/components/DetailProductBlock';
  import GroupBuyTeamMemberList from '@/pages/GroupBuy/components/TeamMemberList';
  import GroupBuyRule from '@/pages/GroupBuy/components/DetailRule';
  import TeamStatus from '@/pages/GroupBuy/components/TeamDetailStatus';
  import { getGroupBuyTeam } from '@/services/groupGuy';

  export default {
    name: 'GroupBuyTeamDetail',
    metaInfo: {
      title: '拼团详情',
    },
    components: {
      GroupBuyProduct,
      GroupBuyTeamMemberList,
      GroupBuyRule,
      TeamStatus,
    },
    data() {
      return {
        product: {
          id: 0,
          cover: '',
          title: '',
          price: 0,
          benefit: null,
          productType: '',
          isMember: false,
        },
        activity: {
          id: 0,
          duration: '',
          teamSize: 0,
          rule: null,
          status: '',
          captainPrice: 0,
        },
        team: {
          id: 0,
          expiredTime: 0,
          isMember: false,
          members: [],
          status: '',
        },
        qrCode: {
          src: '',
          name: '',
        },
        render: {
          primaryPrice: {
            current: {
              value: 0,
              name: '',
            },
            origin: {
              value: 0,
              name: '',
            },
            benefit: null,
          },
          buttons: [
            {
              type: '',
              action: '',
              hint: '',
              targetType: '',
              targetId: 0,
              disabled: false,
            },
          ],
        },
        currentTime: 0,
      };
    },
    computed: {
      originPrice() {
        return this.render.primaryPrice.origin.value;
      },
    },
    methods: {
      async getTeamDetail(id) {
        const data = await getGroupBuyTeam(id);
        this.product = data.product;
        this.activity = data.activity;
        this.team = data.team;
        this.qrCode = data.qrCode;
        this.render = data.render;
        this.currentTime = data.currentTime;
      },
    },
    created() {
      this.getTeamDetail(this.$route.params.id);
    },
    beforeRouteUpdate(to, from, next) {
      const { id } = to.params;
      this.getTeamDetail(id);
      next();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-group-buy-team-detail {
    height: 100%;
    overflow: scroll;
  }

  .block-section {
    margin-bottom: @size-base;
  }

  .team-action-container {
    background-color: @color-white;
    padding: @size-base @size-medium;
    position: relative;
    &:before {
      position: absolute;
      top: 0;
      left: 30px;
      content: '';
      width: 690px;
      height: 1px;
      background: @background-color-base;
    }
  }
</style>
